import { useEvent } from 'rc-util';
import raf from 'rc-util/lib/raf';
import * as React from 'react';
import showWaveEffect from "./WaveEffect";
import { TARGET_CLS } from "./type";
export default function useWave(nodeRef, className, component) {
  var showWave = useEvent(function (event) {
    var node = nodeRef.current;
    if (!node) {
      return;
    }
    var targetNode = node.querySelector(".".concat(TARGET_CLS)) || node;

    // const { showEffect } = wave || {};

    // Customize wave effect
    showWaveEffect(targetNode, {
      className: className,
      component: component,
      event: event
    });
  });
  var rafId = React.useRef();

  // Merge trigger event into one for each frame
  var showDebounceWave = function showDebounceWave(event) {
    raf.cancel(rafId.current);
    rafId.current = raf(function () {
      showWave(event);
    });
  };
  return showDebounceWave;
}